import * as React from 'react';
import { Link } from 'react-router-dom';
import { UitkSelect } from 'uitk-react-select';
import { UitkHeading } from 'uitk-react-text';
import { ViewLarge, Viewport, ViewSmall } from 'bernie-view';
import { RoomComponentDesktop } from './room-component-desktop';
import { RoomComponentMobile } from './room-component-mobile';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';

export interface RoomComponentProps {
  onAdultCountChange(event: any): void;
  onChildCountChange(event: any): void;
  roomCount: any;
  childComponent: any;
}
export class RoomComponent extends React.Component<RoomComponentProps, any> {
  public constructor(props) {
    super(props);
  }

  public renderAdults() {
    const adultArray = [1, 2, 3, 4, 5, 6];
    let opt;

    return adultArray.map((adult) => {
      if (adult > 1) {
        opt = (
          <option key={adult} value={adult}>
            {adult} Adults
          </option>
        );
      } else {
        opt = (
          <option key={adult} value={adult}>
            {adult} Adult
          </option>
        );
      }

      return opt;
    });
  }

  public renderKids() {
    const childArray = [0, 1, 2, 3, 4, 5, 6];
    let opt;

    return childArray.map((child) => {
      if (child > 1 || child < 1) {
        opt = (
          <option key={child} value={child}>
            {child} Kids
          </option>
        );
      } else {
        opt = (
          <option key={child} value={child}>
            {child} Kid
          </option>
        );
      }

      return opt;
    });
  }

  public render() {
    const { onAdultCountChange, onChildCountChange, roomCount } = this.props;
    const roomLabel = `Room ${roomCount}`;

    return (
      <>
        <UitkLayoutFlex space="three" className="deeplink-builder__room-component">
          <>
            <UitkLayoutFlexItem>
              <UitkHeading tag="h2" size={5}>
                {roomLabel}
              </UitkHeading>
            </UitkLayoutFlexItem>
            <UitkLayoutFlexItem>
              <div>
                <UitkSelect
                  id={`adultCount${roomCount}`}
                  label=""
                  icon="person"
                  onChange={onAdultCountChange}
                  hasVisibleLabel={false}
                >
                  {this.renderAdults()}
                </UitkSelect>
              </div>
            </UitkLayoutFlexItem>
            <UitkLayoutFlexItem>
              <div>
                <UitkSelect
                  id={`child-count${roomCount}`}
                  label=""
                  icon="person"
                  onChange={onChildCountChange}
                  hasVisibleLabel={false}
                >
                  {this.renderKids()}
                </UitkSelect>
              </div>
            </UitkLayoutFlexItem>
          </>
        </UitkLayoutFlex>

        <Viewport>
          <ViewLarge>
            <RoomComponentDesktop roomCount={this.props.roomCount} childComponent={this.props.childComponent} />
          </ViewLarge>
          <ViewSmall>
            <RoomComponentMobile roomCount={this.props.roomCount} childComponent={this.props.childComponent} />
          </ViewSmall>
        </Viewport>
      </>
    );
  }
}
